'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Utils = require('./Utils');

var _SubContent = require('./Utils/SubContent');

var _SubContent2 = _interopRequireDefault(_SubContent);

var _DatePicker = require('./DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DatePickerInput = function (_Component) {
    _inherits(DatePickerInput, _Component);

    function DatePickerInput() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, DatePickerInput);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DatePickerInput.__proto__ || Object.getPrototypeOf(DatePickerInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            datePickerAlignment: 'bottom',
            datePickerOn: false,
            tooltipPosition: null
        }, _this.textInput = null, _this.formControl = null, _this.datePicker = null, _this.storeTextInputRef = function (ref) {
            _this.textInput = ref;

            if (_this.props.innerRef) {
                _this.props.innerRef(ref);
            }
        }, _this.storeFormControlRef = function (ref) {
            return _this.formControl = ref;
        }, _this.storeDatePickerRef = function (ref) {
            return _this.datePicker = ref;
        }, _this.openDatePicker = function () {
            var position = _this.formControl.getBoundingClientRect();

            var newState = {
                datePickerOn: true,
                tooltipPosition: position.height
            };

            if (position.top + position.height / 2 < window.innerHeight / 2) {
                newState.datePickerAlignment = 'bottom';
            } else {
                newState.datePickerAlignment = 'top';
            }

            _this.setState(newState);
            _this.listenDatePickerClick();
        }, _this.closeDatePicker = function () {
            _this.setState({ datePickerOn: false, tooltipPosition: null });
            _this.stopListenDatePickerClick();
            _this.handleBlur();
        }, _this.handleFocus = function () {
            _this.openDatePicker();
            _this.props.handleFocus && _this.props.handleFocus();
        }, _this.handleBlur = function () {
            _this.props.handleBlur && _this.props.handleBlur();
        }, _this.handleDateChange = function (value) {
            _this.updateValue(value);
            _this.closeDatePicker();
        }, _this.validateMousePosition = function (e) {
            if (_this.state.datePickerOn) {
                // Get the area covered by the date picker
                var pDP = _this.datePicker.getBoundingClientRect();
                var pFC = _this.formControl.getBoundingClientRect();

                // Get the position of the mouse
                var mouseX = e.clientX;
                var mouseY = e.clientY;

                if (pDP.left < mouseX && mouseX < pDP.right && pDP.top < mouseY && mouseY < pDP.bottom) {
                    // Mouse is within the date picker.
                    // Do nothing, just handy to use the positive test to get our else condition.
                } else if (pFC.left < mouseX && mouseX < pFC.right && pFC.top < mouseY && mouseY < pFC.bottom) {
                    // Mouse is within the form control div.
                    // Also do nothing, but wait for it...
                } else {
                    // Mouse is both ouside of the date picker and the form control, hide the date picker.
                    _this.closeDatePicker();
                }
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DatePickerInput, [{
        key: 'updateValue',
        value: function updateValue(value) {
            if (value !== this.props.value) {
                this.props.updateValue(_defineProperty({}, this.props.name, value));
            }
        }

        /*
         * Handle focus
         */


        /*
         * Handle blur
         */


        /*
         * Handle value change from the date picker
         */

    }, {
        key: 'listenDatePickerClick',


        /*
         * Start listening to click events, if the user clicks out of the date picker, then hide it.
         */
        value: function listenDatePickerClick() {
            document.addEventListener('click', this.validateMousePosition);
        }

        /*
         * Stop listening to click events.
         */

    }, {
        key: 'stopListenDatePickerClick',
        value: function stopListenDatePickerClick() {
            document.removeEventListener('click', this.validateMousePosition);
        }

        /*
         * Check if the mouse click is within the date picker or form-control area
         * If the mouse click is outside of the area, then we hide the date picker
         */

    }, {
        key: 'render',
        value: function render() {
            var inputId = (0, _Utils.generateId)(this.props.name);

            var groupClasses = (0, _classnames2.default)({
                'form__group': true,
                'form__group--error': this.props.errors && this.props.errors.length
            });

            return _react2.default.createElement(
                'div',
                { className: groupClasses },
                _react2.default.createElement(
                    _Label2.default,
                    { htmlFor: inputId },
                    this.props.label
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'form__control', ref: this.storeFormControlRef },
                    _react2.default.createElement('input', {
                        disabled: this.props.disabled,
                        id: inputId,
                        name: this.props.name,
                        onBlur: this.handleBlur,
                        onFocus: this.handleFocus,
                        placeholder: this.props.placeholder,
                        readOnly: true,
                        ref: this.storeTextInputRef,
                        required: this.props.required,
                        type: 'text',
                        value: this.props.value || ''
                    }),
                    this.state.datePickerOn && _react2.default.createElement(_DatePicker2.default, {
                        alignment: this.state.datePickerAlignment,
                        date: this.props.value && (0, _moment2.default)(this.props.value),
                        dateFormat: this.props.dateFormat || null,
                        innerRef: this.storeDatePickerRef,
                        max: this.props.max && (0, _moment2.default)(this.props.max),
                        min: this.props.min && (0, _moment2.default)(this.props.min),
                        onChange: this.handleDateChange,
                        position: this.state.tooltipPosition,
                        weekDayStart: this.props.weekDayStart || null
                    })
                ),
                _react2.default.createElement(_SubContent2.default, { errors: this.props.errors, help: this.props.help })
            );
        }
    }]);

    return DatePickerInput;
}(_react.Component);

DatePickerInput.propTypes = _extends({}, _Utils.formControlPropTypes, _Utils.focussablePropTypes, {

    dateFormat: _propTypes2.default.string,
    max: _propTypes2.default.string, // date string, optional
    min: _propTypes2.default.string, // date string, optional
    placeholder: _propTypes2.default.string,
    required: _propTypes2.default.bool,
    success: _propTypes2.default.bool,
    value: _propTypes2.default.string, // make sure value is specifically a string, as it should be a date string
    weekDayStart: _propTypes2.default.number
});
DatePickerInput.defaultProps = {
    disabled: false,
    placeholder: '',
    weekDayStart: 1
};
exports.default = DatePickerInput;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@matyas/matyaskar-forked-react-ui/lib/DatePickerInput.js
// module id = 393
// module chunks = 0